const RoutingPaths = {
  layout: "/dashboard",
  login: "/login",
  home: "/home",
  home: "/",

  // path define for students module
  studentsList: "/students",
  addStudents: "/students/add",
  editStudents: "/students/edit",
  viewStudents: "/students/view",
  viewStudentsDetail: "/students/detail",
  viewStudentsAttendance: "/students/attendance",
  downloadFeeSlip: "/students/fee/slip/",
  transactionHistory: "/students/transaction/history",

  // paths define for teachers module
  teachersList: "/teachers",
  addTeachers: "/teachers/add",
  editTeachers: "/teachers/edit",
  viewTeachers: "/teachers/view",
  viewTeachersAttendance: "/teachers/attendance",


  // paths define for demo students module
  demoStudentsList: "/students/demo/",
  addDemoStudents: "/students/demo/add",
  editDemoStudents: "/students/demo/edit",

  // paths define for pte students module
  pteStudentsList: "/students/pte/",
  addPteStudents: "/students/pte/add",
  editPteStudents: "/students/pte/edit",

  // paths define for salary expenses module
  salaryExpensesList: "/expenses/salary",
  addSalaryexpenses: "/expenses/salary/add",
  editSalaryExpenses: "/expenses/salary/edit",
  salarySlip: "/expenses/salary/slip",


  // paths define for basic expenses module
  basicExpensesList: "/expenses/basic",
  addBasicExpenses: "/expenses/basic/add",
  editBasicExpenses: "/expenses/basic/edit",

  // paths define for different batches module
  batchesList: "/batches",
  addBatches: "/batches/add",
  editBatches: "/batches/edit",
  viewBatches: "/batches/view",

  // paths define for mock test module
  mockTestList: "/mock/test/",
  addMockTextInfo: "/mock/test/add",
  editMockTextInfo: "/mock/test/edit",

  // paths define for students' performance module
  studentPerformanceList: "/students/performance/",
  addStudentPerformance: "/students/performance/add",
  editStudentPerformance: "/students/performance/edit",

  // paths define for attendance module
  attendance: "/attendance",
  teachersAttendance: "/teachers/attendance",
  studentsAttendance: "/students/attendance",

  // paths define for users module
  usersList: "/users",
  addUsers: "/users/add",
  editUsers: "/users/edit",

  // paths define for fee module
  feesData: "/fees",

  // paths define for visa module
  visaList: "/visa",
  addVisa: "/visa/add",
  editVisa: "/visa/edit",

  // paths define for note module
  notesList: "/notes",
  addNotes: "/notes/add",
  editNotes: "/notes/edit",

  // paths define for profile module
  profile: "/profile",
};

export default RoutingPaths;
